import { headerV2Tokens, livescoreHeaderTokens, oddsTokens, playoffTokens } from './general-components';

export const basketballLivescoreTokens = {
  ...oddsTokens,
  ...livescoreHeaderTokens,
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  oddsContainerPrimaryBgColor: '',
  pillBackgroundColor: '',
  pillActiveBackgroundColor: '',
  accentPrimaryBgColor: '',
  standingsLinkColor: '',
  scoreAccentColor: '',
};

export const basketballSingleEventTokens = {
  ...oddsTokens,
  hiContrast: '',
  sportEntityContainerPrimaryBgColor: '',
};

export const basketballKnockoutStandingsTokens = {
  ...headerV2Tokens,
  ...playoffTokens,
  hiContrast: '',
  primaryBackgroundColor: '',
  rowBackgroundColor: '',
  tableHeaderBG: '',
  tableBorderColor: '',
  tableRankHighlightColor: '',
  highLighted: '',
  pillBackgroundColor: '',
  dropdownBorderColor: '',
  dropdownBtnColor: '',
};

export const basketballTeamProgrammeTokens = {
  ...headerV2Tokens,
  hiContrast: '',
  rowBackgroundColor: '',
  oddsContainerPrimaryBgColor: '',
  oddsSelectionBackgroundColor: '',
  oddItemHoverColor: '',
  primaryBackgroundColor: '',
  pillBackgroundColor: '',
  pillActiveBackgroundColor: '',
  dropdownBtnColor: '',
  standingsLinkColor: '',
  scoreAccentColor: '',
};

export const basketballTournamentProgrammeTokens = {
  ...headerV2Tokens,
  hiContrast: '',
  rowBackgroundColor: '',
  oddsContainerPrimaryBgColor: '',
  oddsSelectionBackgroundColor: '',
  oddItemHoverColor: '',
  primaryBackgroundColor: '',
  pillBackgroundColor: '',
  pillActiveBackgroundColor: '',
  dropdownBtnColor: '',
  standingsLinkColor: '',
  scoreAccentColor: '',
};
